import React from "react";
import { Layout } from "../components/Layout";
import { EditableSubjectChip } from "../components/start/EditableSubjectChip";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { styled } from "../utils/alias";

const SubjectTypeSection = styled.div`
    margin-bottom: 1rem;
`;

const ChipList = styled.div`
    display: flex;
    justify-content: center;
`;

let Start = () => {
    const defaultSubjects = [
        { id: "politics", name: "Politics", defaultValue: 0.2, type: "topic" },
        { id: "sports", name: "Sports", defaultValue: 0.2, type: "topic" },
        {
            id: "celebrities",
            name: "Celebrities",
            defaultValue: 0.2,
            type: "topic"
        },
        { id: "ukLocation", name: "UK", defaultValue: 0.6, type: "location" }
    ];
    return (
        <Layout thinHeader={true}>
            <SubjectTypeSection>
                <h2>Topics</h2>
                <ChipList>
                    {defaultSubjects
                        .filter(s => s.type === "topic")
                        .map(topic => (
                            <EditableSubjectChip {...topic} key={topic.id} />
                        ))}
                </ChipList>
            </SubjectTypeSection>
            <SubjectTypeSection>
                <h2>Places</h2>
                <ChipList>
                    {defaultSubjects
                        .filter(s => s.type === "location")
                        .map(place => (
                            <EditableSubjectChip {...place} key={place.id} />
                        ))}
                </ChipList>
            </SubjectTypeSection>
            <Button component={Link} to={"/"}>
                Done
            </Button>
        </Layout>
    );
};

export { Start };



// WEBPACK FOOTER //
// ./src/pages/Start.js